module.exports = __webpack_public_path__ + "img/c2.c39ec126.png";